module.exports = {
  name: "",
  description: "",
  type: "MODEL",
  format: "REVIT",
  units: "INCH",
  rows: [{
    original_index: 0,
    cells: [45,         0,          0,          4,          4,          16,         -16]
  },
  {
    original_index: 0,
    cells: [135,        0,          0,          -4,         4,          16,         -16]
  },
  {
    original_index: 0,
    cells: [90,     0,      0,      0,      11.3137085]
  }
  ],
  width: 12,
  height: 12,
  mode: 'raster',
  variables: [],
  calculator: undefined,
  notes: undefined,
  tags: [],
  projects: [],
  text: `;%UNITS=INCH
;%VERSION=3.0
;
*Chevron
;%TYPE=MODEL
;
;angle, x,      y,      shift,  offset, dash,   space
45,     0,      0,      4,      4,      16,     -16
135,    0,      0,      -4,     4,      16,     -16
90,     0,      0,      0,      11.3137085`,
  scale_factor: 1,
  decimal_places: 8,
  private: false
}


// WEBPACK FOOTER //
// ./src/patterns/tutorial_intro_01.js